import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./Card.css";

export default class Card extends Component {
  state = {
    open: this.props.open || false,
    toggledOpen: this.props.open,
    collapsible: this.props.collapsible || false,
  };

  componentDidUpdate = () => {
    // Allows parent to toggle all, but still allows independant toggling
    if (this.state.toggledOpen !== this.props.open) {
      this.setState({
        toggledOpen: this.props.open,
        open: this.props.open,
      });
    }
  };

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  collapseButton = () => {
    if (this.props.collapsible) {
      return (
        <a
          href={"#collapse"}
          className="flex-right"
          onClick={() => this.toggle()}
        >
          {this.state.open ? "Hide" : "Show"} Details{" "}
          <FontAwesomeIcon
            icon={this.state.open ? faChevronUp : faChevronDown}
          />
        </a>
      );
    }
  };

  render() {
    const isOpen = this.state.open || !this.state.collapsible;
    return (
      <div className="clr-card">
        <header className="clr-card__header">
          {this.props.image_src ? (
            <div className={`clr-card__image ${this.props.image_variant || ""}`}>
              <img src={this.props.image_src} alt={this.props.image_alt} />
            </div>
          ) : null}
          <div>
            <h1 className="clr-card__title">{this.props.title}</h1>
            {this.props.subtitles?.length
              ? this.props.subtitles.map((s, i) => <div className="clr-card__subtitle" key={i}>{s}</div>)
              : null}
          </div>
        </header>

        <div className="clr-card__content">
          <div className={`clr-card__collapse${isOpen ? "" : " is-closed"}`} aria-hidden={!isOpen}>
            <div className="clr-card__collapse-inner">{this.props.children}</div>
          </div>
          {this.collapseButton()}
        </div>
        <span className="clr-card__actions">
          {this.props.actions?.length
            ? this.props.actions.map((a, i) =>
                a ? <div key={i}>{a}</div> : null
              )
            : null}
        </span>
      </div>
    );
  }
}
